// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Close: React.FC<{ width?: number; height?: number }> = ({ width = 22, height = 22 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 22 22">
            <path
                fill="currentColor"
                d="M21.46 19.19a1.643 1.643 0 0 1 0 2.328 1.654 1.654 0 0 1-2.335 0l-8.124-8.163-8.182 8.16a1.654 1.654 0 0 1-2.334 0 1.643 1.643 0 0 1 0-2.327l8.185-8.157L.483 2.809a1.643 1.643 0 0 1 0-2.327 1.654 1.654 0 0 1 2.334 0L11 8.706l8.182-8.16a1.654 1.654 0 0 1 2.334 0 1.643 1.643 0 0 1 0 2.328l-8.185 8.157 8.127 8.16Z"
            />
        </svg>
    );
};

export default React.memo(Close);
